import { useMutation } from '@tanstack/react-query';
import { api } from 'shared/api/client';

export const useXhtmlValidation = () => {
  return useMutation({
    mutationFn: async ({ documentRevisionId }: { documentRevisionId: string }) => {
      const { data } = await api.GET('/xhtml/validation', { params: { query: { documentRevisionId } } });
      return data;
    },
  });
};
